import React from 'react';
import PropTypes from 'prop-types';
import css from './StatusBox.module.scss';

/**
 * Small colored rounded-square indicator used to visually communicate a status. Consumed
 * directly (e.g. inside lesson row indicators) and internally by `StatusLegendItem`.
 */
const StatusBox = ({color, label}) => (
  <span
    className={css.statusBox}
    style={{backgroundColor: color}}
    title={label}
    aria-label={label}
  />
);

StatusBox.propTypes = {
  color: PropTypes.string.isRequired,
  label: PropTypes.string,
};

export default StatusBox;
